import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import AuthResource from '../../api/service/AuthResource';

const initialState = {
  currentUser: {},
  editProfileLoading: false,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(current.fulfilled, (state, action) => {
      state.currentUser = action.payload;
    });

    //update
    builder
      .addCase(updateCurrentUser.fulfilled, (state, action) => {
        state.currentUser = {
          ...action.payload,
          organisations: state.currentUser.organisations,
        };
        state.editProfileLoading = false;
      })
      .addCase(updateCurrentUser.pending, (state) => {
        state.editProfileLoading = true;
      })
      .addCase(updateCurrentUser.rejected, (state) => {
        state.editProfileLoading = false;
      });
  },
});

export default authSlice.reducer;

export const current = createAsyncThunk('auth/current', async () => {
  const authResource = new AuthResource();
  const { status, data } = await authResource.current();
  if (status === 200) {
    return data;
  }
  return false;
});

export const updateCurrentUser = createAsyncThunk(
  'auth/updateCurrentUser',
  async (initialData, { rejectWithValue }) => {
    const authResource = new AuthResource();
    const { payload } = initialData;
    const { status, data } = await authResource.update(payload);
    if (status === 200) {
      return data;
    }
    return rejectWithValue('Profile update failed.');
  }
);
